module.exports = ":host{\n    width: 100%;\n    height: 100%;\n}\n\n#container{\n    height: calc(100% - 4px);\n    margin: 2px 4px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/console-pane/console-pane.component.css
// module id = ./src/app/components/console-pane/console-pane.component.css
// module chunks = main